import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';

const ToastTitle = ({ children, ...rest }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.wrenchToastTitle} {...rest}>
      {children}
    </div>
  );
};

ToastTitle.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ToastTitle;
